import type { PipelineSummary } from '@/api/types'
import Select from '@/components/ui/Select'

/**
 * Board header title: the selected pipeline's name plus a compact selector,
 * shown only when there is more than one pipeline to choose from.
 */
export default function PipelineSwitcher({
  pipelines,
  pipeline,
  onSelect,
}: {
  pipelines: PipelineSummary[]
  pipeline: PipelineSummary
  onSelect: (id: string) => void
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* The page is "Deals" (what the nav item says); the pipeline is a detail beside it. */}
      <h1 className="text-xl font-semibold text-brand-darkest">Deals</h1>
      {pipelines.length <= 1 && <span className="text-sm text-gray-400">{pipeline.name}</span>}
      {pipelines.length > 1 && (
        <Select
          size="sm"
          value={pipeline.id}
          onChange={(e) => onSelect(e.target.value)}
          className="w-56"
          aria-label="Switch pipeline"
        >
          {pipelines.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </Select>
      )}
    </div>
  )
}
